import { makeAutoObservable, action } from 'mobx';
import {
  fetchJobApplicants,
  rejectJobApplicant,
  acceptJobApplicant
} from '../api/SlmService';
import { addToFavoritesById, removeFromFavoritesById } from '../api/FavoritingService';
import notificationStore from './NotificationStore';

class JobApplicantStore {

  isJobApplicantsLoading = false;

  jobPostingMetadata = {};

  jobApplicants = [];

  jobApplicantsPaginationInfo = {};

  page = 1;

  sort = {
    by: null,
    order: null
  };

  filter = undefined;

  notificationStore = {};

  constructor(newNotificationStore) {
    makeAutoObservable(this);
    this.notificationStore = newNotificationStore;
  }

  resetSort = () => {
    this.sort = {
      by: null,
      order: null
    };
  };

  setSort = (next) => {
    this.sort = { ...next };
  };

  setFilter = (value) => {
    this.filter = value;
  };

  resetFilter = () => {
    this.filter = undefined;
  };

  setJobApplicants = (list) => {
    this.jobApplicants = list;
  };

  setIsJobApplicantsLoading = (bool) => {
    this.isJobApplicantsLoading = bool;
  };

  setJobApplicantsPaginationInfo = (paginationInfo) => {
    this.jobApplicantsPaginationInfo = paginationInfo;
  };

  setJobPostingMetaData = (jobPosting) => {
    this.jobPostingMetadata = jobPosting;
  };

  setPage = (p) => {
    this.page = Number(p);
  };

  fetchJobApplicants = (withLoader = true) => {
    if (withLoader) {
      this.setIsJobApplicantsLoading(true);
    }
    fetchJobApplicants(this.jobPostingMetadata.jobPostingId, this.page, this.sort, this.filter).then(
      action('success', (res) => {
        this.setJobApplicants(res.applicantDisplays);
        this.setJobApplicantsPaginationInfo(res.metadata.paginationInfo);
        this.setJobPostingMetaData(res.metadata.jobPosting);
      }),
      action('error', () => {
        this.notificationStore.setError('Failed to fetch job applicants.');
      })
    ).finally(() => {
      this.setIsJobApplicantsLoading(false);
    });
  };

  acceptJobApplicant = async (applicantId) => {
    const oldList = [...this.jobApplicants];

    acceptJobApplicant(this.jobPostingMetadata.jobPostingId, applicantId).then(
      action('success', () => {
        this.fetchJobApplicants(false);
      }),
      action('error', () => {
        this.setJobApplicants(oldList);
        this.notificationStore.setError('Failed to accept job applicant.');
      })
    );
  };

  rejectJobApplicant = async (applicantId) => {
    const oldList = [...this.jobApplicants];

    rejectJobApplicant(this.jobPostingMetadata.jobPostingId, applicantId).then(
      action('success', () => {
        this.fetchJobApplicants(false);
      }),
      action('error', () => {
        this.setJobApplicants(oldList);
        this.notificationStore.setError('Failed to reject job applicant.');
      })
    );
  };

  removeApplicantFromFavorites = async (candidateId) => {
    const oldList = [...this.jobApplicants];
    const tempList = [...this.jobApplicants];
    const idx = tempList.findIndex((item) => item.candidateId === candidateId);
    const candidate = tempList[idx];
    const updatedCandidate = {
      ...candidate,
      favorite: false
    };
    tempList.splice(idx, 1, updatedCandidate);
    this.setJobApplicants(tempList);

    removeFromFavoritesById(candidateId).then(
      action('success', () => {
        this.fetchJobApplicants(false);
      }),
      action('error', () => {
        this.setJobApplicants(oldList);
        this.notificationStore.setError('Failed to remove applicant from favorites.');
      })
    );
  };

  addApplicantToFavorites = async (candidateId) => {
    const oldList = [...this.jobApplicants];
    const tempList = [...this.jobApplicants];
    const idx = tempList.findIndex((item) => item.candidateId === candidateId);
    const candidate = tempList[idx];
    const updatedCandidate = {
      ...candidate,
      favorite: true
    };
    tempList.splice(idx, 1, updatedCandidate);
    this.setJobApplicants(tempList);

    addToFavoritesById(candidateId).then(
      action('success', () => {
        this.fetchJobApplicants(false);
      }),
      action('error', () => {
        this.setJobApplicants(oldList);
        this.notificationStore.setError('Failed to add applicant to favorites.');
      })
    );
  };

}

export default new JobApplicantStore(notificationStore);
